import { Box, Typography } from "@mui/material";

import { OmniStringToDate } from "../../utils/helpers";

// Matches a plain date string with no time component, e.g. "2026-01-01".
const DATE_ONLY_PATTERN = /^\d{4}-\d{2}-\d{2}$/;

const getDateFromValue = value => {
  if (value == null || value === "") {
    return null;
  }

  const stringValue = String(value).trim();

  if (DATE_ONLY_PATTERN.test(stringValue)) {
    return new Date(OmniStringToDate(stringValue));
  }

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) {
    return null;
  }

  return date;
};

/**
 * Standardized Date/Time cell renderer for material-react-table.
 *
 * Use directly as a column's `Cell`:
 *   Cell: MRTDateTimeCell
 *
 * Handles two value shapes:
 *  - Full ISO date-time strings (createdAt / updatedAt): renders the date on
 *    top and a 12-hour time below.
 *  - Date-only strings "YYYY-MM-DD" (startDate / endDate): renders the date on
 *    top and a timestamp below if available.
 */
const MRTDateTimeCell = ({ cell }) => {
  const value = cell?.getValue();

  if (value == null || value === "") {
    return "";
  }

  const date = getDateFromValue(value);

  if (date == null) {
    return "";
  }

  const dateLabel = date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
  });

  const timeLabel = date.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  });

  return (
    <Box component="span">
      <Typography
        variant="h6"
        sx={{
          textAlign: "center",
          marginBottom: "2px",
          borderBottom: "2px solid",
          lineHeight: 1.2,
        }}
      >
        {dateLabel}
      </Typography>

      <Typography
        variant="body1"
        fontWeight={100}
        sx={{
          textAlign: "center",
          lineHeight: 1.1,
        }}
      >
        {timeLabel}
      </Typography>
    </Box>
  );
};

export default MRTDateTimeCell;
